import { AIRPORT_COORDS } from '../Constants/airportCoords';

export const getRouteColor = (status) => {
  switch(status?.toLowerCase()) {
    case 'arrived': return '#10b981';
    case 'departed': return '#3b82f6';
    case 'scheduled': return '#8b5cf6';
    case 'cancelled': return '#ef4444';
    case 'delayed': return '#f59e0b';
    default: return '#6b7280';
  }
};

export const getCoordinates = (iata) => {
  return AIRPORT_COORDS[iata] || null;
};

export const formatTime = (timeString) => {
  if (!timeString) return 'N/A';
  return timeString;
};